import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-bottom: 28px;
`

export const Titulo = styled.h1`
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  line-height: 35px;
  margin: 0 0 12px;
`

export const Contador = styled.p`
  font-size: 16px;
  line-height: 22px;
  margin: 0 0 8px;
  color: ${Cores.CINZA_2};
`

export const BarraFundo = styled.div`
  width: 100%;
  max-width: 420px;
  height: 10px;
  background: ${Cores.CINZA_3_CLARO};
  border-radius: 8px;
  overflow: hidden;
  margin: 8px 0;
`

export const BarraPreenchida = styled.div<{ percentual: number }>`
  height: 100%;
  width: ${props => props.percentual}%;
  background: ${Cores.PRIMARIA_2};
  transition: width 0.2s ease-in;
`

export const Consequencia = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin: 8px 0 0;
  color: ${Cores.CINZA_2};
`
